//angular imports
import { signal, Signal, WritableSignal } from "@angular/core";

//local imports
import { IListItem, ListItem, Messenger } from "@app/shared";
import { AbstractDepartmentNavModel, SelectDepartmentMessage } from "@app/catalog-common";
import { DepartmentModel } from "@app/catalog";


export class DepartmentsNavModel 
  extends AbstractDepartmentNavModel<DepartmentModel> {

  public override allowMultiSelect?: WritableSignal<boolean> = signal<boolean>(false);

 constructor(
    messenger: Messenger,
    items: Signal<DepartmentModel[]>
  ) {
    super(messenger, items);
  }

  public select(item: IListItem): void {
    const navItem = item as ListItem<DepartmentModel>;
    this.messenger.send(new SelectDepartmentMessage(navItem.value));
  }

}